import { render, staticRenderFns } from "./xiangjin.vue?vue&type=template&id=0e22f5ee&"
import script from "./xiangjin.vue?vue&type=script&lang=js&"
export * from "./xiangjin.vue?vue&type=script&lang=js&"
import style0 from "./xiangjin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports